import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "action-list" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { class: "dialog-footer" }

import { getCurrentInstance, reactive, ref } from 'vue'
import Pagination from '@/components/Pagination.vue'
import SelectBrand from '@/components/SelectBrand.vue'
import {
    getFinalPayListApi,
    delFinalPayApi,
    saveFinalPayApi,
    getFinalPayShieldInfoApi,
    saveFinalPayShieldApi,
} from "@/apis/marketing";

enum ActivityType {
    '实付满减' = 1,
}

interface FullRowI {
    id?: number,
    full_amount: number,
    discount_amount: number,
    status: number,
}
interface PackageI {
    id?: number,
    start_at: string,
    end_at: string,
    full_rule: Array<FullRowI>,
    status_name?: string,
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FinalPaySale',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const catOptions = [
    { label: '蛋糕', value: 1 },
    { label: '零食', value: 5 },
    { label: '鲜花', value: 8 },
]
const filters = reactive({
    page: 1, // 当前页码
    page_size: 10, // 每页显示条数
})

const emptyRow = {
    start_at: '',
    end_at: '',
    full_rule: [
        {
            full_amount: 0,
            discount_amount: 0,
            status: 1, // 1-正常，2-关闭
        }
    ]
}

// 开始日期须大于今天
const disabledStartDate = (date:string) => {
    return (new Date(date)).getTime() < Date.now()
}
// 结束日期须大于开始日期
const disabledEndDate = (date:string) => {
    return (new Date(date)).getTime() < (new Date(rowData.value.start_at + ' 00:00:00')).getTime() || (new Date(date)).getTime() < Date.now()
}
const settingDialog = ref(false)
const rowData = ref<PackageI>(JSON.parse(JSON.stringify(emptyRow)))
const shieldDialog = ref(false)
const shieldForm = reactive({
    id: '',
    no_cat_ids: [] as number[],
    no_brand_ids: [] as number[]
})
const shieldLogList = ref<any[]>([])

const openShieldDialog = async (row: any) => {
    shieldForm.id = row.id
    shieldForm.no_cat_ids = []
    shieldForm.no_brand_ids = []
    shieldLogList.value = []
    shieldDialog.value = true
    await getShieldInfo(row.id)
}

// 获取屏蔽设置
const getShieldInfo = async (activityId: number) => {
    const { code, data, msg } = await getFinalPayShieldInfoApi(activityId) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })

    const { config, log_list  } = data
    shieldForm.no_cat_ids = config.no_cat_ids.map((item: string) => Number(item)) || []
    shieldForm.no_brand_ids = config.no_brand_ids.map((item: string) => Number(item)) || []
    shieldLogList.value = log_list
}

// 保存屏蔽设置
const onSaveShield = async () => {
    if (!shieldForm.id) return
    const { code, msg } = await saveFinalPayShieldApi({
        id: shieldForm.id,
        no_cat_ids: shieldForm.no_cat_ids.join(','),
        no_brand_ids: shieldForm.no_brand_ids.join(',')
    }) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })
    proxy.$message({ type: 'success', message: '保存成功' })
    shieldDialog.value = false
}

const openDialog = (row = null) => {
    if (row) {
        rowData.value = JSON.parse(JSON.stringify(row))
    } else {
        rowData.value = JSON.parse(JSON.stringify(emptyRow))
    }
    settingDialog.value = true
}

const onCancel = (id) => {
    proxy.$confirm(`确定要关闭该活动吗？`, '提示', {
        type: 'warning',
    }).then(async () => {
        const { code, msg } = await delFinalPayApi(id) as any
        if (code != 200) return proxy.$message({type: 'error', message: msg})

        proxy.$message({type: 'success', message: '操作成功'})
        getList()
    }).catch(() => {
        proxy.$message({type: 'info', message: '取消操作'})
    })
}

// index-当前操作行，type：1-满金额，2-减金额
const checkPrice = (row, type:number, rowIndex:number) => {
    let { full_amount, discount_amount } = row
    if (type === 1) {
        if (!full_amount) {
            proxy.$message({type: 'error', message: '请填写满金额'})
            return false
        }
        if (rowData.value.full_rule.findIndex((item:any, index) => Number(item.full_amount) === Number(full_amount) && index !== rowIndex) > -1) {
            proxy.$message({type: 'error', message: '满金额不能重复'})
            row.full_amount = 0
            return false
        }
        if (Number(full_amount) <= Number(discount_amount)) {
            proxy.$message({type: 'error', message: '满金额必须大于减金额'})
            row.full_amount = 0
            return false
        }
    } else {
        if (!discount_amount) {
            proxy.$message({type: 'error', message: '请填写减金额'})
            return false
        }
        if (rowData.value.full_rule.findIndex((item:any, index) => Number(item.discount_amount) === Number(discount_amount) && index !== rowIndex) > -1) {
            proxy.$message({type: 'error', message: '减金额不能重复'})
            row.discount_amount = 0
            return false
        }
        if (Number(discount_amount) >= Number(full_amount)) {
            proxy.$message({type: 'error', message: '减金额必须小于满金额'})
            row.discount_amount = 0
            return false
        }
    }
}

const onItemCancel = (index) => {
    proxy.$confirm(`确定要关闭该活动吗？`, '提示', {
        type: 'warning',
    }).then(() => {
        rowData.value.full_rule[index].status = 2
    }).catch(() => {
        proxy.$message({type: 'info', message: '取消操作'})
    })
}

const onAdd = () => {
    rowData.value.full_rule.push({
        full_amount: 0,
        discount_amount: 0,
        status: 1,
    })
}

const checkData = () => {
    const {start_at, end_at} = rowData.value
    if (!start_at || !end_at) {
        proxy.$message({type: 'error', message: '请选择活动日期'})
        return false
    }
    if (new Date(start_at +'00:00:00').getTime() > new Date(end_at +'00:00:00').getTime()) {
        proxy.$message({type: 'error', message: '活动开始日期不能大于结束日期'})
        return false
    }
    let errorIndex = rowData.value.full_rule?.findIndex((item:any) => !item.full_amount || !item.discount_amount || Number(item.full_amount) <= Number(item.discount_amount))
    if (errorIndex > -1) {
        proxy.$message({type: 'error', message: `第${errorIndex +1}行数据有误，请修改后重新保存`})
        return false
    }
    return true
}

const onSave = async () => {
    const isValidData = checkData()
    if (isValidData) {
        const { id, start_at, end_at, full_rule } = rowData.value
        const { code, msg } = await saveFinalPayApi({
            id,
            start_at,
            end_at,
            amount_info: full_rule,
        }) as any
        if (code != 200) return proxy.$message({type: 'error', message: msg})

        proxy.$message({type: 'success', message: '保存成功'})
        settingDialog.value = false
        getList()
    }
}

// 获取列表数据
const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getFinalPayListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    tableData.value = data.data
    total.value = data.total
}
getList()

const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_decimal = _resolveDirective("decimal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("h4", null, "平台官方立减配置", -1)),
    _createVNode(_component_el_row, { class: "mt20" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openDialog()))
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("+设置满减")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      class: "mt20",
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "活动ID"
        }),
        _createVNode(_component_el_table_column, { label: "活动类型" }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(ActivityType[row.activity_type]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "满减规则",
          width: "220"
        }, {
          default: _withCtx(({row}) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.full_rule, (item) => {
              return (_openBlock(), _createElementBlock("p", {
                class: _normalizeClass(item.status == 1 ? 'color-primary' : 'color9')
              }, _toDisplayString(`实付金额满 ￥${item.full_amount}，减 ￥${item.discount_amount}`), 3))
            }), 256))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "start_at",
          label: "开始日期"
        }),
        _createVNode(_component_el_table_column, {
          prop: "end_at",
          label: "结束日期"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status_name",
          label: "活动状态"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "190"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: row.status_name === '已结束' || row.status_name === '已关闭',
                onClick: ($event: any) => (openDialog(row))
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("编辑")
                ])),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: row.status_name === '已结束' || row.status_name === '已关闭',
                onClick: ($event: any) => (onCancel(row.id))
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("关闭")
                ])),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "设置满减规则",
      modelValue: settingDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((settingDialog).value = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (settingDialog.value = false))
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onSave
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("保存")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "活动日期",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: rowData.value.start_at,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rowData.value.start_at) = $event)),
              disabled: rowData.value.status_name === '已开始',
              "disabled-date": disabledStartDate,
              type: "date",
              placeholder: "开始日期",
              "value-format": "YYYY-MM-DD",
              clearable: "",
              onClear: _cache[2] || (_cache[2] = ($event: any) => (rowData.value.end_at = ''))
            }, null, 8, ["modelValue", "disabled"]),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "divider" }, "-", -1)),
            _createVNode(_component_el_date_picker, {
              modelValue: rowData.value.end_at,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rowData.value.end_at) = $event)),
              "disabled-date": disabledEndDate,
              type: "date",
              placeholder: "结束日期",
              "value-format": "YYYY-MM-DD",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, {
          data: rowData.value.full_rule,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "单笔订单实付需满足金额" }, {
              default: _withCtx(({row, $index}) => [
                _withDirectives(_createVNode(_component_el_input, {
                  modelValue: row.full_amount,
                  "onUpdate:modelValue": ($event: any) => ((row.full_amount) = $event),
                  disabled: rowData.value.status_name === '已开始' && row.id,
                  placeholder: "填写满金额",
                  onBlur: ($event: any) => (checkPrice(row, 1, $index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onBlur"]), [
                  [_directive_decimal]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "满减金额" }, {
              default: _withCtx(({row, $index}) => [
                _withDirectives(_createVNode(_component_el_input, {
                  modelValue: row.discount_amount,
                  "onUpdate:modelValue": ($event: any) => ((row.discount_amount) = $event),
                  disabled: rowData.value.status_name === '已开始' && row.id,
                  placeholder: "填写满减金额",
                  onBlur: ($event: any) => (checkPrice(row, 2, $index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onBlur"]), [
                  [_directive_decimal]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "70"
            }, {
              default: _withCtx(({row, $index}) => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    disabled: row.status == 2 || !row.id,
                    onClick: ($event: any) => (onItemCancel($index))
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("关闭")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_row, {
          class: "mt10",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: onAdd
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("+添加")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "不参加平台官方立减",
      modelValue: shieldDialog.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((shieldDialog).value = $event)),
      width: "900px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (shieldDialog.value = false))
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onSaveShield
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode("保存")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "120px",
          class: "mt20"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "不参加的分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: shieldForm.no_cat_ids,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((shieldForm.no_cat_ids) = $event)),
                  multiple: "",
                  placeholder: "可多选",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(catOptions, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "不参加的品牌" }, {
              default: _withCtx(() => [
                _createVNode(SelectBrand, {
                  modelValue: shieldForm.no_brand_ids,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((shieldForm.no_brand_ids) = $event)),
                  multiple: "",
                  placeholder: "可多选",
                  ifBody: 0,
                  classNames: ['w-100']
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, {
          "content-position": "left",
          style: {"margin-top":"60px"}
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode("操作日志")
          ])),
          _: 1
        }),
        _createVNode(_component_el_table, {
          data: shieldLogList.value,
          stripe: "",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "不参加分类",
              prop: "no_cat_name",
              width: "120"
            }),
            _createVNode(_component_el_table_column, {
              label: "不参加品牌",
              prop: "no_brand_name",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "admin_name",
              label: "操作人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "add_time",
              label: "操作时间",
              width: "145"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})